import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LangToIcon } from './localization/localization';

export enum SparrowIconEnum {
  CaretDown = 'caret-down',
  CaretDoubleDown = 'caret-double-down',
  MagnifyingGlass = 'magnifying-glass',
  Plus = 'plus',
  PlusCircle = 'plus-circle',
  SortDown = 'sort-down',
  SortUp = 'sort-up',
  SortUpDown = 'sort-up-down',
  XCircle = 'x-circle',
  XCircleFill = 'x-circle-fill',
  Flag = 'flag',
  InfoCircle = 'info-circle',
  Question = 'question',
  Warning = 'warning',
  WarningCircle = 'warning-circle',
  ArrowsLeftRight = 'arrows-left-right',
  ArrowsOut = 'arrows-out',
  ArrowLineDown = 'arrow-line-down',
  ArrowLeft = 'arrow-left',
  ArrowCounterClockwise = 'arrow-counter-clockwise',
  ArrowLineRight = 'arrow-line-right',
  ArrowLineUpRight = 'arrow-line-up-right',
  ArrowSquareRight = 'arrow-square-right',
  Bookmark = 'bookmark',
  Calendar = 'calendar',
  ChatMessage = 'chat-message',
  CheckCircle = 'check-circle',
  CheckCircleFill = 'check-circle-fill',
  PauseCircle = 'pause-circle',
  Check = 'check',
  HighlighterCircle = 'highlighter-circle',
  IsoGlobe = 'iso-globe',
  PaperPlaneTilt = 'paper-plane-tilt',
  PushPin = 'push-pin',
  SquareHalf = 'square-half',
  Copy = 'copy',
  Duplicate = 'duplicate',
  CirclesThreePlus = 'circles-three-plus',
  Database = 'database',
  DataCleaning = 'data-cleaning',
  Edit = 'edit',
  CsvFile = 'csv-file',
  DocFile = 'doc-file',
  GeneralFile = 'general-file',
  PdfFile = 'pdf-file',
  XlsxFile = 'xlsx-file',
  LinkFile = 'link-file',
  Files = 'files',
  FileArrowUp = 'file-arrow-up',
  Filter = 'filter',
  FilterClear = 'filter-clear',
  GitFork = 'git-fork',
  ImageCloseIcon = 'image-close-icon',
  ImageSquare = 'image-square',
  Images = 'images',
  CameraRotate = 'camera-rotate',
  CameraPlus = 'camera-plus',
  Camera = 'camera',
  LocationPin = 'location-pin',
  Lock = 'lock',
  LockLaminated = 'lock-laminated',
  Menu = 'menu',
  Notebook = 'notebook',
  NumHash = 'num-hash',
  NotSubsetOf = 'not-subset-of',
  Percent = 'percent',
  OutlineList = 'outline-list',
  OutlineClose = 'outline-close',
  Package = 'package',
  PartPooling = 'part-pooling',
  PartAdd = 'part-add',
  PartUse = 'part-use',
  OrdersEmptyCart = 'orders-empty-cart',
  PoolingIcon = 'pooling-icon',
  SearchSettings = 'search-settings',
  Printer = 'printer',
  QrCode = 'qr-code',
  Save = 'save',
  SparrowLogo = 'sparrow-logo',
  SparrowIcon = 'sparrow-icon',
  SparrowLabel = 'sparrow-label',
  StockManagement = 'stock-management',
  StockPlanning = 'stock-planning',
  Table = 'table',
  TreeStructure = 'tree-structure',
  TrashBin = 'trash-bin',
  At = 'at',
  UserRevert = 'user-revert',
  UserCircle = 'user-circle',
  UserCircleMinus = 'user-circle-minus',
  UserCircleGear = 'user-circle-gear',
  BookDesc = 'book-desc',
  PuzzlePiece = 'puzzle-piece',
  CornersIn = 'corners-in',
  Eye = 'eye',
  EyeSlash = 'eye-slash',
  SignOut = 'sign-out',
  ClockCounterClockwise = 'clock-counter-clockwise',
  Tag = 'tag',
  Truck = 'truck',
  StoreFront = 'storefront',
  Factory = 'factory',
  ImgCard = 'img-card',
  DotsThreeVertical = 'dots-three-vertical',
  ChartBarHorizontal = 'chart-bar-horizontal',
}

const icons = [
  // Flag icons
  { name: LangToIcon.en, url: 'assets/icons/flag-uk.svg' },
  { name: LangToIcon.de, url: 'assets/icons/flag-de.svg' },
  { name: LangToIcon.fr, url: 'assets/icons/flag-fr.svg' },
  // Action icons
  { name: SparrowIconEnum.CaretDown, url: 'assets/icons/caret-down.svg' },
  { name: SparrowIconEnum.CaretDoubleDown, url: 'assets/icons/caret-double-down.svg' },
  { name: SparrowIconEnum.MagnifyingGlass, url: 'assets/icons/magnifying-glass.svg' },
  { name: SparrowIconEnum.Plus, url: 'assets/icons/plus.svg' },
  { name: SparrowIconEnum.PlusCircle, url: 'assets/icons/plus-circle.svg' },
  { name: SparrowIconEnum.PauseCircle, url: 'assets/icons/pause-circle.svg' },
  { name: SparrowIconEnum.SortDown, url: 'assets/icons/sort-arrow-down.svg' },
  { name: SparrowIconEnum.SortUp, url: 'assets/icons/sort-arrow-up.svg' },
  { name: SparrowIconEnum.SortUpDown, url: 'assets/icons/sort-up-down.svg' },
  { name: SparrowIconEnum.XCircle, url: 'assets/icons/x-circle.svg' },
  { name: SparrowIconEnum.XCircleFill, url: 'assets/icons/x-circle-fill.svg' },
  // Alert icons
  { name: SparrowIconEnum.Flag, url: 'assets/icons/flag.svg' },
  { name: SparrowIconEnum.InfoCircle, url: 'assets/icons/info-circle.svg' },
  { name: SparrowIconEnum.Question, url: 'assets/icons/question.svg' },
  { name: SparrowIconEnum.Warning, url: 'assets/icons/warning.svg' },
  { name: SparrowIconEnum.WarningCircle, url: 'assets/icons/warning-circle.svg' },
  // Arrow icons
  { name: SparrowIconEnum.ArrowsLeftRight, url: 'assets/icons/arrows-left-right.svg' },
  { name: SparrowIconEnum.ArrowsOut, url: 'assets/icons/arrows-out.svg' },
  { name: SparrowIconEnum.ArrowLineDown, url: 'assets/icons/arrow-line-down.svg' },
  { name: SparrowIconEnum.ArrowLeft, url: 'assets/icons/arrow-left.svg' },
  { name: SparrowIconEnum.ArrowCounterClockwise, url: 'assets/icons/arrow-counter-clockwise.svg' },
  { name: SparrowIconEnum.ArrowLineRight, url: 'assets/icons/arrow-line-right.svg' },
  { name: SparrowIconEnum.ArrowLineUpRight, url: 'assets/icons/arrow-line-up-right.svg' },
  { name: SparrowIconEnum.ArrowSquareRight, url: 'assets/icons/arrow-square-right.svg' },
  // Book icons
  { name: SparrowIconEnum.Bookmark, url: 'assets/icons/bookmark.svg' },
  // Calendar icons
  { name: SparrowIconEnum.Calendar, url: 'assets/icons/calendar.svg' },
  // Chat icons
  { name: SparrowIconEnum.ChatMessage, url: 'assets/icons/chat-message.svg' },
  // Check icons
  { name: SparrowIconEnum.CheckCircle, url: 'assets/icons/check-circle.svg' },
  { name: SparrowIconEnum.CheckCircleFill, url: 'assets/icons/check-circle-fill.svg' },
  { name: SparrowIconEnum.Check, url: 'assets/icons/check.svg' },
  // Circle icons
  { name: SparrowIconEnum.HighlighterCircle, url: 'assets/icons/highlighter-circle.svg' },
  { name: SparrowIconEnum.IsoGlobe, url: 'assets/icons/iso-globe.svg' },
  { name: SparrowIconEnum.PaperPlaneTilt, url: 'assets/icons/paper-plane-tilt.svg' },
  { name: SparrowIconEnum.PushPin, url: 'assets/icons/push-pin.svg' },
  { name: SparrowIconEnum.SquareHalf, url: 'assets/icons/square-half.svg' },
  // Copy/Duplicate icons
  { name: SparrowIconEnum.Copy, url: 'assets/icons/copy.svg' },
  { name: SparrowIconEnum.Duplicate, url: 'assets/icons/duplicate.svg' },
  // Data/Database icons
  { name: SparrowIconEnum.CirclesThreePlus, url: 'assets/icons/circles-three-plus.svg' },
  { name: SparrowIconEnum.Database, url: 'assets/icons/database.svg' },
  { name: SparrowIconEnum.DataCleaning, url: 'assets/icons/data-cleaning.svg' },
  // Edit icons
  { name: SparrowIconEnum.Edit, url: 'assets/icons/edit.svg' },
  // File icons
  { name: SparrowIconEnum.CsvFile, url: 'assets/file-icons/csv-file.svg' },
  { name: SparrowIconEnum.DocFile, url: 'assets/file-icons/doc-file.svg' },
  { name: SparrowIconEnum.GeneralFile, url: 'assets/file-icons/general-file.svg' },
  { name: SparrowIconEnum.PdfFile, url: 'assets/file-icons/pdf-file.svg' },
  { name: SparrowIconEnum.XlsxFile, url: 'assets/file-icons/xlsx-file.svg' },
  { name: SparrowIconEnum.LinkFile, url: 'assets/file-icons/link-file.svg' },
  { name: SparrowIconEnum.Files, url: 'assets/icons/files.svg' },
  { name: SparrowIconEnum.ImgCard, url: 'assets/icons/img-card.svg' },
  { name: SparrowIconEnum.FileArrowUp, url: 'assets/icons/file-arrow-up.svg' },
  // Filter icons
  { name: SparrowIconEnum.Filter, url: 'assets/icons/filter.svg' },
  { name: SparrowIconEnum.FilterClear, url: 'assets/icons/filter-clear.svg' },
  // Git icons
  { name: SparrowIconEnum.GitFork, url: 'assets/icons/git-fork.svg' },
  // Image icons
  { name: SparrowIconEnum.ImageCloseIcon, url: 'assets/icons/img-close.svg' },
  { name: SparrowIconEnum.ImageSquare, url: 'assets/icons/image-square.svg' },
  { name: SparrowIconEnum.Images, url: 'assets/icons/images.svg' },
  { name: SparrowIconEnum.CameraRotate, url: 'assets/icons/camera-rotate.svg' },
  { name: SparrowIconEnum.CameraPlus, url: 'assets/icons/camera-plus.svg' },
  { name: SparrowIconEnum.Camera, url: 'assets/icons/camera.svg' },
  // Location icons
  { name: SparrowIconEnum.LocationPin, url: 'assets/icons/location-pin.svg' },
  // Lock icons
  { name: SparrowIconEnum.Lock, url: 'assets/icons/lock.svg' },
  { name: SparrowIconEnum.LockLaminated, url: 'assets/icons/lock-laminated.svg' },
  // Menu icons
  { name: SparrowIconEnum.Menu, url: 'assets/icons/menu.svg' },
  // Notebook icons
  { name: SparrowIconEnum.Notebook, url: 'assets/icons/notebook.svg' },
  // Number icons
  { name: SparrowIconEnum.NumHash, url: 'assets/icons/num-hash.svg' },
  { name: SparrowIconEnum.Percent, url: 'assets/icons/percent.svg' },
  // Outline icons
  { name: SparrowIconEnum.OutlineList, url: 'assets/icons/outline-list.svg' },
  { name: SparrowIconEnum.OutlineClose, url: 'assets/icons/outline-close.svg' },
  // Package icons
  { name: SparrowIconEnum.Package, url: 'assets/icons/package.svg' },
  // Part icons
  { name: SparrowIconEnum.PartPooling, url: 'assets/icons/part-pooling.svg' },
  { name: SparrowIconEnum.PartAdd, url: 'assets/icons/part-add-icon.svg' },
  { name: SparrowIconEnum.PartUse, url: 'assets/icons/part-use-icon.svg' },
  // Pool icons
  { name: SparrowIconEnum.OrdersEmptyCart, url: 'assets/pool-icons/orders-empty-cart.svg' },
  { name: SparrowIconEnum.PoolingIcon, url: 'assets/icons/pooling-icon.svg' },
  { name: SparrowIconEnum.SearchSettings, url: 'assets/pool-icons/search-settings.svg' },
  // Printer icons
  { name: SparrowIconEnum.Printer, url: 'assets/icons/printer.svg' },
  // QR code icon
  { name: SparrowIconEnum.QrCode, url: 'assets/icons/qr-code.svg' },
  // Save icon
  { name: SparrowIconEnum.Save, url: 'assets/icons/save.svg' },
  // Sparrow icons
  { name: SparrowIconEnum.SparrowLogo, url: 'assets/icons/sparrow-logo.svg' },
  { name: SparrowIconEnum.SparrowIcon, url: 'assets/icons/sparrow-icon.svg' },
  { name: SparrowIconEnum.SparrowLabel, url: 'assets/icons/sparrow-label.svg' },
  // Stock icons
  { name: SparrowIconEnum.StockManagement, url: 'assets/icons/stock-management.svg' },
  { name: SparrowIconEnum.StockPlanning, url: 'assets/icons/stock-planning.svg' },
  // Table icons
  { name: SparrowIconEnum.Table, url: 'assets/icons/table.svg' },
  // Tree icons
  { name: SparrowIconEnum.TreeStructure, url: 'assets/icons/tree-structure.svg' },
  // Trash icon
  { name: SparrowIconEnum.TrashBin, url: 'assets/icons/trash-bin.svg' },
  // User icons
  { name: SparrowIconEnum.At, url: 'assets/icons/at.svg' },
  { name: SparrowIconEnum.UserRevert, url: 'assets/icons/user-revert.svg' },
  { name: SparrowIconEnum.UserCircle, url: 'assets/icons/user-circle.svg' },
  { name: SparrowIconEnum.UserCircleMinus, url: 'assets/icons/user-circle-minus.svg' },
  { name: SparrowIconEnum.UserCircleGear, url: 'assets/icons/user-circle-gear.svg' },
  // Other icons
  { name: SparrowIconEnum.NotSubsetOf, url: 'assets/icons/not-subset-of.svg' },
  { name: SparrowIconEnum.PuzzlePiece, url: 'assets/icons/puzzle-piece.svg' },
  { name: SparrowIconEnum.BookDesc, url: 'assets/icons/book-desc.svg' },
  { name: SparrowIconEnum.CornersIn, url: 'assets/icons/corners-in.svg' },
  { name: SparrowIconEnum.Eye, url: 'assets/icons/eye.svg' },
  { name: SparrowIconEnum.EyeSlash, url: 'assets/icons/eye-slash.svg' },
  { name: SparrowIconEnum.SignOut, url: 'assets/icons/sign-out.svg' },
  { name: SparrowIconEnum.ClockCounterClockwise, url: 'assets/icons/clock-counter-clockwise.svg' },
  { name: SparrowIconEnum.Tag, url: 'assets/icons/tag.svg' },
  { name: SparrowIconEnum.Truck, url: 'assets/icons/truck.svg' },
  { name: SparrowIconEnum.StoreFront, url: 'assets/icons/storefront.svg' },
  { name: SparrowIconEnum.Factory, url: 'assets/icons/factory.svg' },
  { name: SparrowIconEnum.DotsThreeVertical, url: 'assets/icons/dots-three-vertical.svg' },
  { name: SparrowIconEnum.ChartBarHorizontal, url: 'assets/icons/chart-bar-horizontal.svg' },
];

export class IconsRegistry {
  static registerIcons(matIconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    icons.forEach((icon: { name: string; url: string }) => {
      const svgUrl = icon.url;
      const safeUrl = sanitizer.bypassSecurityTrustResourceUrl(svgUrl);
      matIconRegistry.addSvgIcon(icon.name, safeUrl);
    });
  }
}
